import { Button, Typography } from '@global-engineering-shared/gweb-material-ui';

import { useDialog } from 'context/DialogProvider/DialogProvider';
import useStyles from 'features/Import/components/ImportButton/ImportButton.styles';
import { IMPORT_DIALOG_ID } from 'utils/defaults';

const ImportButton = () => {
  const { openDialog } = useDialog();
  const classes = useStyles();

  return (
    <Button className={classes.importButton} onClick={() => openDialog(IMPORT_DIALOG_ID)}>
      <Typography className={classes.importButtonText}>Import</Typography>
    </Button>
  );
};

export default ImportButton;
